<div class="progress-wrapper">
  <div class="progress">
    <div class="bar" [style.width.%]="getPercent()"></div>
  </div>
  <div class="navigation" [ngClass]="{'no-counters': !counters}" *ngIf="parts.length">
    <div class="separate-columns">
      <div class="separate-column" [style.width.%]="100 / parts.length" *ngFor="let p of parts;let i = index">
        <div *ngIf="counters && p.max && isFinite(p.max)" class="counter">{{ p.max | numberFormat: '0a' }}<ng-container
            *ngIf="i === parts.length-1">+</ng-container></div>
      </div>
    </div>
    <div class="captions">
      <div class="caption" [style.width.%]="100 / parts.length" *ngFor="let p of parts">
        <span [tooltip]="p.tooltip ? p.tooltip : ''" tooltipPlacement="top" [innerHtml]="p.label"></span>
      </div>
    </div>
  </div>
</div>
